// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"535":"login","583":"fsd"}[chunkId] + "." + {"535":"58930431","583":"24bacd33"}[chunkId] + ".css";
};